// React Dependencies
import { useState, useLayoutEffect, useRef } from 'react';

// Internal Dependencies
import { IsEmpty } from './checks';

export default function useResized() {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (!IsEmpty(ref.current)) {
      const observer = new ResizeObserver(([entry]) => {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      });

      observer.observe(ref.current);

      return () => observer.disconnect();
    }
  }, []);

  return [ref, size];
}
